export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

if (APP_VERSION === '1.0.0' && process.env.NODE_ENV !== 'test') {
  console.warn('⚠️ Warning: Using fallback version. Version injection may have failed.');
}

/**
 * Get a versioned key for a given key.
 * @param {string} key - The key to version.
 * @returns The versioned key.
 */
export const getVersionedKey = (key: string): string => `${key}_v${APP_VERSION}`;

/**
 * Clear old versioned keys from localStorage.
 * @param {string} baseKey - The base key to clear.
 */
export const clearOldVersionedKeys = (baseKey: string): void => {
  const currentVersionedKey = getVersionedKey(baseKey);
  const keysToRemove = Object.keys(localStorage).filter(
    (key) => key.startsWith(`${baseKey}`) && key !== currentVersionedKey
  );

  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });
};

/**
 * Initialize version cleanup for the given base keys.
 */
export const initializeVersionCleanup = (): void => {
  const baseKeys: string[] = ['filters'];

  baseKeys.forEach((key) => {
    clearOldVersionedKeys(key);
  });
};
